import { cn } from '@/lib/utils';
import type { ReactNodeCompat } from '@/types/react-compat';

interface DashboardLayoutProps {
  children: ReactNodeCompat;
  className?: string;
}

export function DashboardLayout({ children, className }: DashboardLayoutProps) {
  return (
    <div className={cn('min-h-screen w-full space-y-6', className)}>
      {children}
    </div>
  );
}
